import React from 'react';
import PropTypes from 'prop-types';
import { useIntl } from 'react-intl';

import { Wrapper, Title, Text } from './styled';

const NoteBlock = ({ titleId = '', textId, isWarning = false }) => {
  const intl = useIntl();

  return (
    <Wrapper $warning={ isWarning }>
      {titleId && <Title>{intl.formatMessage({ id: titleId })}</Title>}
      <Text>{intl.formatMessage({ id: textId })}</Text>
    </Wrapper>
  );
};

NoteBlock.propTypes = {
  titleId: PropTypes.string,
  textId: PropTypes.string.isRequired,
  isWarning: PropTypes.bool
};

export default NoteBlock;
